// connection.js
import { Events } from "./events.js";

export const ConnectionQuality = {
    _latencySamples: [],

    addSample(ms) {
        this._latencySamples.push(ms);
        if (this._latencySamples.length > 50) {
            this._latencySamples.shift();
        }
        Events.emit("conn:qualityChanged", this.getQuality());
    },

    getAverage() {
        if (!this._latencySamples.length) return null;
        return this._latencySamples.reduce((a, b) => a + b, 0) / this._latencySamples.length;
    },

    getQuality() {
        const avg = this.getAverage();
        if (avg === null) return "unknown";
        if (avg < 100) return "good";
        if (avg < 500) return "medium";
        return "bad";
    }
};
